import { initialLetters, login, register } from "../../commons/utils/Utils";
import React, { createRef, useEffect, useRef, useState } from "react";
import styles from "./avatar.module.scss";
import { MdPerson } from "react-icons/md";
import { Perfil } from "./Perfil";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";

interface AvatarProps {
    children?: any;
    isLogged?: boolean;
    firstName?: string;
    lastName?: string;
    email?: string;
}
export const Avatar: React.FC<AvatarProps> = ({
    children,
    isLogged,
    lastName,
    firstName,
    email,
}) => {
    const [show, setShow] = useState(false);

    const activeSlideRef = useRef(null);

    function handleClickOutside(event) {
        if (
            activeSlideRef &&
            !activeSlideRef?.current?.contains(event.target)
        ) {
            setShow(false);
        }
    }

    useEffect(() => {
        if (!show && activeSlideRef) {
            document.addEventListener("click", handleClickOutside);
        }
    }, []);
    return isLogged ? (
        <div
            className={styles.box}
            ref={activeSlideRef}
            onClick={() => setShow(true)}
        >
            <div className={styles.box__initial_letters}>
                {initialLetters(`${firstName} ${lastName}`)}
            </div>
            <div className={styles.box__text_name}>
                Olá,&nbsp;
                <span className={styles.box__text_name__first_name}>
                    {firstName}
                </span>{" "}
            </div>
            <div className={styles.box__arrow} onClick={() => setShow(!show)}>
                {show ? (
                    <div onClick={() => setShow(!show)}>
                        <MdKeyboardArrowUp />
                    </div>
                ) : (
                    <div onClick={() => setShow(!show)}>
                        <MdKeyboardArrowDown />
                    </div>
                )}
            </div>

            {show ? (
                <Perfil
                    firstName={firstName}
                    lastName={lastName}
                    email={email}
                ></Perfil>
            ) : (
                false
            )}
        </div>
    ) : (
        <div className={styles.box}>
            <div className={styles.box__initial_letters}>
                <MdPerson className={styles.box__icon} />
            </div>
            <div className={styles.box__text_name}>
                Olá, faça o &nbsp;
                <a
                    className={styles.box__initial_letters__a_login}
                    onClick={() => (window.location.href = login())}
                >
                    LOGIN
                </a>
                &nbsp;
                <br />
                ou &nbsp;
                <a
                    className={styles.box__initial_letters__a_signin}
                    onClick={() => (window.location.href = register())}
                >
                    CADASTRE-SE
                </a>{" "}
                &nbsp;
            </div>
        </div>
    );
};
